import React from "react";

const ExpectedSpending = ({ width }) => (
  <svg
    width={width || "14"}
    height={width || "14"}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="7"
      cy="7.5"
      r="6.5"
      stroke="#387CFF"
      stroke-linecap="round"
      stroke-dasharray="2 4"
    />
  </svg>
);

export default ExpectedSpending;
